<template>
  <div class="main">
    <div class="curse-content">
      <div class="curse-tex">当前位置：首页 > 专家列表</div>
      <div class="curse-btn" @click="addExpert(false)">添加专家</div>
    </div>
    <div class="list-content">
      <div class="search-box">
        <div class="search-item">
          <el-input v-model="keyword" placeholder="专家名称"></el-input>
        </div>
        <div class="search-item">
          <el-button type="primary" icon="el-icon-refresh" @click="searchreset"
            >重置</el-button
          >
          <el-button type="primary" icon="el-icon-search" @click="searchFun"
            >搜索</el-button
          >
        </div>
      </div>
      <el-table
        :data="list"
        border
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
        style="width: 100%"
      >
        <el-table-column type="index" label="序号" width="100">
        </el-table-column>
        <el-table-column prop="nickname" label="专家名称"> </el-table-column>
        <el-table-column prop="username" label="专家账号"> </el-table-column>
        <el-table-column prop="phone" label="专家类型">
          <template slot-scope="scope">
            {{ scope.row.role_type | role_type }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="初审审核进度"
          v-if="user.id === 7"
        >
          <template slot-scope="scope">
            {{ scope.row.check_number }}/{{ scope.row.check_project_number }}
          </template>
        </el-table-column>
        <el-table-column
          prop="status"
          label="复审审核进度"
          v-if="user.id === 7"
        >
          <template slot-scope="scope">
            {{ scope.row.recheck_number }}/{{
              scope.row.recheck_project_number
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="addExpert(scope.row)"
              >编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page-box flex justify-center padding-top-sm">
        <el-pagination
          class="page-all margin-bottom"
          background
          @current-change="init"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <add-expert-dialog :dialog="dialog" :info="row" @watchState="watchState" />
  </div>
</template>
<script>
import { find2CN, zhDate } from "@/tools";
import { baseURL } from "@/config";
import { getAdminList } from "@/api/admin";
import AddExpertDialog from "@/views/adminhome/common/AddExpertDialog";
import { expert_role_types } from "@/utils/utils";

export default {
  name: "index",
  data() {
    return {
      dialog: false,
      row: {},
      zhDate: zhDate,
      baseURL: baseURL,
      list: [],
      keyword: "",
      page: 1,
      limit: 10,
      total: 20,
    };
  },
  computed: {
    token() {
      return this.$store.state.admintoken;
    },
    user() {
      return this.$store.state.adminuser;
    },
  },
  components: { AddExpertDialog },
  created() {
    this.$emit("setActive", {
      active: 4,
    });
    this.init();
  },
  methods: {
    // 获取列表
    async init() {
      let _data = await getAdminList(this.keyword, 2, this.page, this.limit);
      if (_data.code === 200) {
        this.list = _data.data.data;
        this.total = _data.data.total;
      } else {
        this.$message.error(_data.message);
      }
    },

    searchFun() {
      this.page = 1;
      this.init();
    },

    searchreset() {
      this.keyword = "";
      this.page = 1;
      this.init();
    },

    addExpert(row) {
      this.row = row || "";
      this.dialog = true;
    },

    watchState(data) {
      if (data) {
        this.init();
      }
      this.dialog = false;
    },
  },
  watch: {},
  filters: {
    role_type(val) {
      return find2CN(Number(val), expert_role_types);
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;

  .curse-content {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-right: 15px;

    .curse-tex {
      font-size: 16px;
      color: #333333;
    }

    .curse-btn {
      width: 108px;
      height: 36px;
      background-color: #5298e2;
      border-radius: 10px 10px 0px 0px;
      text-align: center;
      line-height: 36px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }
  }

  .list-content {
    width: 100%;
    min-height: 500px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .search-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;

      .search-item {
        width: 33.3%;
        padding-right: 20px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
